import * as React from 'react'
import ScrollAnimation from 'react-animate-on-scroll'
import ReactPlayer from 'react-player'
import PropTypes from 'prop-types'
import Slider from 'react-slick'
import SliderArrow from '../../components/layout/SliderArrow'
import FlickerGallery from '../../components/layout/FlickrGallery'
import styled from '../../utils/styled'
interface MediaItemProps {
  type: string
  url: string
  loop: boolean
  preload: boolean
  className: string
  playing: boolean
  background: boolean
  config: any
}

export const MediaItem: React.SFC<MediaItemProps> = ({
  type,
  url,
  caption,
  className = '',
  loop = false,
  preload = false,
  playing = false
  background = false
  config = null
}) => (
  <ScrollAnimation className="media-section" animateIn="headerLineIn" animateOnce={true}>
    {type == 'image' ? (
      <ScrollAnimation duration={2} className="image-zoom" animateIn="zoomBack" animateOnce={true}>
        <img src={url} width="100%" />
        {caption && (<Caption className="image-caption">{caption}</Caption>)}
      </ScrollAnimation>
    ) : type == 'flickr' ? (
      <FlickerGallery search="72157627491430747" />
    ) : (
      <ReactPlayer preload={preload.toString()} loop={loop} url={url} playing={playing} background={background.toString()} config={{
        vimeo: {
          playerOptions: { background: true }
        }
      }} />

    )}

  </ScrollAnimation>
)
const Caption = styled('div')`
padding: .2rem 0rem;
width:100%;
font-weight: 300;
`
// style={{
//   backgroundImage: 'url(' + (url === undefined ? 'none' : url) + ') ',
//   opacity: 1
// }}
export default MediaItem
